import Cookies from "js-cookie";

import { PROJECT_NAME_COOKIE_KEY } from "../constants";

export const getProjectLogoUrl = (baseUri: string) => {
  const projectName = Cookies.get(PROJECT_NAME_COOKIE_KEY) ?? "";
  return `${baseUri}/initiatives/${encodeURI(
    projectName,
  )}/global/img/logo192.png`;
};
